import { Pickup, StackedPickup } from './Pickup';
import { Dropoff, StackedDropoff } from './Dropoff';

export enum DELIVERY_OPERATIONS {
    PICK_UP = 'pickup',
    DROP_OFF = 'dropoff',
}

export interface Delivery {
    id: number;
    client_reference: string;
    package_description: string;
    package_type: string;
    pickup: Pickup;
    dropoff: Dropoff;
}

export interface StackedDelivery {
    id: number;
    createdAt: Date | string;
    updatedAt: Date | string;
    jobId: number;
    pickup: StackedPickup;
    dropoff: StackedDropoff;
}
